import { Injectable } from '@angular/core';
import { Observable, Subject } from '../util/rxjs';

import { ContextAction } from '../action.model';

export interface ContextEvent {
  $event: MouseEvent;
  host: HTMLElement;
  value: any;
  actions: Array<ContextAction<any>>;
}

@Injectable()
export class ContextMenuService {
  contextEvents$: Observable<ContextEvent>;

  private contextEventStream = new Subject<ContextEvent>();

  constructor() {
    this.contextEvents$ = this.contextEventStream.asObservable();
  }

  show<T>($event: MouseEvent, host: HTMLElement, actions: Array<ContextAction<T>>, value: T) {
    this.contextEventStream.next({ $event, value, host, actions });
    $event.preventDefault();
    $event.stopPropagation();
  }
}

